import { NibTravelHttpError } from '@nibtravel/shared/util/models';

export enum LogLevel {
  Debug = 'Debug',
  Info = 'Information',
  Warning = 'Warning',
  Error = 'Error',
}

export interface LogEntry<T> {
  value: string | T;
  category: string;
  method?: string;
  logToConsole?: boolean;
  correlationId?: string;
  extraProps?: Record<string, any>;
  context?: Record<string, any>;
}

export type HttpErrorLogEntry<T extends NibTravelHttpError> = LogEntry<T>;
export type ExceptionLogEntry<T extends Error> = LogEntry<T>;
export type ErrorLogEntry<T> = LogEntry<T>;
